import { render, staticRenderFns } from "./ChartjsDoughnutChart.vue?vue&type=template&id=7e049553"
import script from "./ChartjsDoughnutChart.vue?vue&type=script&lang=js"
export * from "./ChartjsDoughnutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports